import { Typography, Box } from "@mui/material";
import { HeatBreakdownSkeleton } from "components/layout/heat/HeatBreakdownSkeleton";
import { Fake } from "components/layout/skeleton/Fake";
import { VideoPlayerSkeleton } from "components/video/VideoPlayerSkeleton";
import { Sx } from "utils/sx";

const containerStyles: Sx = theme => ({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,

    [theme.breakpoints.up("xl")]: {
        flexDirection: "row",
        marginTop: 2
    }
});

const videoContainerStyles: Sx = theme => ({
    [theme.breakpoints.up("xl")]: {
        flexBasis: "70vw",
        margin: "0 auto",
        height: 0,
    }
});

export const EventWatchPageSkeleton = () => (
    <Box className="skeleton" sx={containerStyles}>
        <Box sx={videoContainerStyles}>
            <VideoPlayerSkeleton />
        </Box>
        <Box sx={{ width: "100%", maxWidth: "sm", mx: "auto", mt: 2 }}>
            <Typography variant="h4" component="h1" gutterBottom marginLeft={3}><Fake size={28}/></Typography>
            <HeatBreakdownSkeleton />
        </Box>
    </Box>
);
